import { Card, Stack, SxProps, Theme } from '@mui/material';
import { ListTable, ListTableProps, ListTableRow } from 'framework/ui/ui-builder';
import { FilterBar, FilterBarFiltersProps } from '../../components/FilterBar';

export interface RelatedListProps<Row extends ListTableRow = ListTableRow> {
  filterProps?: FilterBarFiltersProps;
  totalRecords?: number;
  listProps: ListTableProps<Row>;
  sx?: SxProps<Theme>;
}

const cardSx: SxProps<Theme> = {
  p: 0,
  overflow: 'auto',
  alignSelf: 'flex-start',
  width: '100%',
  maxWidth: '100%',
};

const RelatedList = <Row extends ListTableRow>({ filterProps, totalRecords, listProps, sx }: RelatedListProps<Row>) => {
  return (
    <Stack sx={sx}>
      {(filterProps || totalRecords !== undefined) && (
        <FilterBar filterProps={filterProps} totalRecords={totalRecords} sx={{ mb: 1 }} />
      )}
      <Card sx={cardSx}>
        <ListTable {...listProps} />
      </Card>
    </Stack>
  );
};

export default RelatedList;
